import type { SmartCreationReviewEditChange } from "@adpilot/shared";

export type AddedTarget = Extract<
  SmartCreationReviewEditChange,
  { operation: "add_target" }
>["target"];
export type AddedNegative = Extract<
  SmartCreationReviewEditChange,
  { operation: "add_negative" }
>["negative"];

export interface QuickTargetValue {
  label: string;
  type: "keyword" | "product";
  match: "broad" | "phrase" | "exact" | "expanded" | "NEGATIVE_EXACT" | "NEGATIVE_PHRASE";
  bid: number;
}

export function quickTargetIdentity(match: string, label: string): string {
  return `${match}:${label.trim().replace(/\s+/g, " ").toLocaleLowerCase("en-US")}`;
}
